import { IAdapter } from "@unifiprotocol/core-sdk";
import { atom } from "recoil";

export const Adapter = atom<IAdapter | undefined>({
  key: "adapter",
  default: undefined,
  dangerouslyAllowMutability: true,
});
